/**
 * The main js file for the theme
 *
 * This is the entry point where all modules are imported and compiled.
 *
 * @package Embark
 * @since   1.0.0
 */

class Embark {
	// Object to store components in order to expose them to other components.
	components = {};

	/**
	 * Set variables for common elements, fonts, breakpoints and dynamically
	 * import all modules for the project.
	 */
	constructor() {
		/**
		 * Common elements used throughout the project.
		 */
		this.els = {
			html: document.documentElement,
			body: document.body,
			header: document.getElementById("js-site-header"),
			headerSearch: document.querySelector(".site-header .search-form"),
			navContainer: document.querySelector(".site-header__navigation"),
			mainMenu: document.querySelector(".main-menu, .mega-menu"),
			navicon: document.getElementById("js-navicon"),
		};

		/**
		 * Each object in this array has the following parameters:
		 *
		 * path: The filepath, without file extension, to import relative to "./theme/".
		 * test: A test to check if the module should be imported or not. Typically,
		 * this is simply checking to see if an element exists in the DOM.
		 */
		this.imports = [
			{
				path: "content-tabs",
				test: document.querySelector(".em-content-tabs"),
			},
			{
				path: "modals",
				test: document.querySelector(".unbranded-link"),
			},
			{
				path: "pop-quiz",
				test: document.querySelector(".em-pop-quiz"),
			},
			{
				path: "symptom-map",
				test: document.querySelector(".em-symptom-map"),
			},
		];

		this.init();
	}

	init = async () => {
		this.importModules();
	};

	/**
	 * Load these modules only when they are needed.
	 *
	 * @since 2.1.1
	 */
	importModules = () => {
		this.imports.forEach(({ path, test }) => {
			if (test) {
				import(
					/* webpackChunkName: "[request]" */
					`./theme/${path}`
				);
			}
		});
	};
}

document.addEventListener("DOMContentLoaded", () => {
	window.embark = new Embark();
});
